import AMapLoader from '@amap/amap-jsapi-loader'
import {
  resetRouter
} from '@/router/index'

import router from '@/router/index'
import {
  logout
} from '@/api/api'
import store from '@/store/';
import {
  ssoLink,
  systemLink
} from '@/settings'
import {
  mapGetters
} from 'vuex'
export default {
  data() {
    return {
      messageItemOld: null, // 缓存上一条消息数据
      messageQueue: [], // 假设你有一个消息队列
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    // // 存入消息队列
    // this.setMessageQueue(type, message)
    // 存入消息队列
    setMessageQueue(type, message, clickType, duration) {
      this.messageQueue.push({
        type: type,
        message: message,
        clickType: clickType || '',
        duration: duration,
      })
      if (this.messageQueue.length === 1) {
        // 调用递归函数开始显示消息
        this.showMessage.call(this, 0);
      }
    },

    // 递归函数，依次显示消息队列中的消息
    showMessage(index) {
      if (index < this.messageQueue.length) {
        const messageItem = this.messageQueue[index];
        if (index > 0) {
          this.messageItemOld = this.messageQueue[index - 1];
        } else {
          this.messageItemOld = null
        }
        if (this.messageItemOld && this.messageItemOld.clickType === messageItem.clickType) {
          // 在消息关闭时递归显示下一个消息
          this.showMessage.call(this, index + 1);
          if (index + 1 === this.messageQueue.length) {
            this.messageQueue = []
          }
        } else {
          this.$message({
            type: messageItem.type,
            message: messageItem.message,
            duration: messageItem.duration || 2000, // 控制每个消息的显示时间
            onClose: () => {
              setTimeout(() => {
                // 在消息关闭时递归显示下一个消息
                this.showMessage.call(this, index + 1);
                if (index + 1 === this.messageQueue.length) {
                  this.messageQueue = []
                }
              }, 100)
            }
          });
        }
      }
    },

    // 监听滚动条位置
    handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      // console.log(scrollTop, 'scrollTop')
      if (scrollTop >= 700) {
        // if (this.obj.code !== 'FT-1VP9') {
        this.toTopSty = {
          position: 'absolute',
          right: 0
        }
        // }
      } else {
        this.toTopSty = {
          position: 'unset'
        }
      }
      // console.log(this.toTopSty, 'this.toTopSty')
    },

    // 进入去登录页 20251107修改 有params时为点击忘记密码
    goLogin(params, go) {
      let jumpLink = systemLink
      const hrefPage = '&hrefPage=official'
      if (jumpLink) {
        if (params) {
          // console.log(params, ssoLink + params + '&href=' + jumpLink + hrefPage, 'params')
          window.location.href = ssoLink + params + '&href=' + jumpLink + hrefPage
        } else {
          window.location.href = ssoLink + '?href=' + jumpLink + hrefPage + '&isLogout=' + (localStorage.getItem(
            'isLogout') || '') + '&fourZOne=' + (go || '') + '&noJump='
        }
        return
      }
    },

    // 重置登录状态
    resetLogin(type, tips, go) {
      console.log(type, tips, go, 'type, tips, go')
      if (type === 'logout') {
        logout({
          businessName: 'official',
          userId: this.userInfo.id,
          ticket: localStorage.getItem('ticket') || '', // 20241205 新增 取当前系统的ticket缓存 区分不同平台的退出登录
          // secret: 'true' // 同一账号同一平台不同浏览器登录： true按平台单独退出登录  ''按平台统一退出登录
        }).then(res => {
          if (res.code === 200) {
            console.log(res.msg, '退出登录成功')
            if (!tips) {
              // 20241205 新增 点击过退出登录标识
              localStorage.setItem('isLogout', 1)
              // this.$message.success('退出登录成功')
              this.setMessageQueue('success', '退出登录成功')
              this.modalShow = false
            }
            // 登录失效 + 清缓存
            this.reset()
          } else {
            // this.$message.error(res.msg)
            this.setMessageQueue('error', res.msg)
          }
        })
      } else {
        // 登录失效 + 清缓存
        this.reset(go)
      }
    },

    // 登录失效 + 清缓存
    reset(go) {
      console.log('reset')
      store.commit('SET_LOGIN', null)
      store.commit('SET_USER_INFO', {})
      resetRouter()
      // 暂时使用
      // let href = window.location.href.split('?')[0]
      // window.location.href = href
      // console.log(window.location.href, 'window.location.href')
      console.log(go, 'go')
      if (go) {
        // 再清除相关缓存
        this.localStorageRemove()
        setTimeout(() => {
          // 进入去登录页
          this.goLogin('', go)
          return
        }, 500)
      } else {
        router.push({
          path: '/'
        })
        // 再清除相关缓存
        this.localStorageRemove()
      }
    },

    // 再清除相关缓存
    localStorageRemove() {
      localStorage.removeItem('userInfo')
      localStorage.removeItem('isLogin')
      localStorage.removeItem('token')
      localStorage.removeItem('logonExpire')

      // 20251006 新增注释 解决退出登录后仍自动登录问题
      // localStorage.removeItem('loginToken')
      // 20241205 新增 删除当前平台的ticket
      localStorage.removeItem('ticket')
      // 20240229 注释
      // sessionStorage.removeItem('token')
      // sessionStorage.removeItem('loginToken')
      // sessionStorage.removeItem('isLogin')
    },

    // // 设置保持登录有效期
    // setLocalExpire(key, expire) {
    //   if (!expire || Number(expire) === 0) {
    //     localStorage.removeItem(key)
    //   } else {
    //     // 86400000一天时间的毫秒数
    //     let time = expire * 1000 * 60 * 60 * 24
    //     let obj = {
    //       time: Date.now(), //存值时间戳
    //       expire: time, //过期时间
    //     }
    //     // 注意，localStorage不能直接存储对象类型，sessionStorage也一样
    //     // 需要先用JSON.stringify()将其转换成字符串，取值时再通过JSON.parse()转换回来
    //     localStorage.setItem(key, JSON.stringify(obj))
    //   }
    // },

    // 获取保持登录有效期
    getLocalExpire(key) {
      let val = localStorage.getItem(key)
      if (val > 0 && Date.now() > val) {
        localStorage.removeItem(key)
        localStorage.removeItem('token')
        // 20240229 注释
        // sessionStorage.removeItem('token')
        // 重置登录状态 => 并退出统一登陆
        this.resetLogin('logout', 'no')
      }
    },

    // 监听滚动条位置
    handleScrollBannerImg() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop

      if (this.$refs.bannerImg) {
        let imgHeight = this.$refs.bannerImg.height

        if (this.title === '商城') {
          if (scrollTop > imgHeight) {
            this.backType = ''
          } else {
            this.backType = 'black'
          }
          console.log(scrollTop, imgHeight, this.$refs.bannerImg, this.backType, this.title)
        } else {
          if (imgHeight === 480) {
            if (scrollTop >= imgHeight - 146) {
              this.backType = ''
            } else {
              this.backType = 'black'
            }
          }
        }
      }

      if (this.$refs.bannerBloHeight && this.title === '技术支持') {
        if (scrollTop > this.$refs.bannerBloHeight.clientHeight - 260) {
          this.backType = ''
        } else {
          this.backType = 'black'
        }
        console.log(scrollTop, 'bannerBloHeight', this.$refs.bannerBloHeight.clientHeight)
      }

      if (this.$refs.bannerImgSec) {
        let imgHeightSec = this.$refs.bannerImgSec.height
        if (imgHeightSec === 330) {
          if (scrollTop >= imgHeightSec - 146) {
            this.backType = ''
          } else {
            this.backType = 'black'
          }
        } else if (imgHeightSec < 330) {
          if (scrollTop >= imgHeightSec - 120) {
            this.backType = ''
          } else {
            this.backType = 'black'
          }
        }

        console.log(imgHeightSec, 'imgHeightSec')
      }
    },

    // 初始化地图
    initMap() {
      AMapLoader.load({
          key: 'da166693496dd417e70e76181146301b', // 申请好的Web端开发者Key，首次调用 load 时必填
          version: '1.4.15', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15（踩坑：2.0.0版本的有问题建议设置低版本）
          plugins: [
            'AMap.ToolBar',
            'AMap.Scale',
            'AMap.MapType',
            'AMap.Geolocation',
            'AMap.CitySearch',
            'AMap.PlaceSearch',
            'AMap.Geocoder'
          ], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
          resizeEnable: true
        })
        .then(AMap => {
          console.log(AMap, 'AMap')
          var _that = this
          var map = new AMap.Map('mapBlo')
          _that.marker = new AMap.Marker({
            position: [121.139418, 41.092875], // 位置
            size: new AMap.Size(35, 35), // 图标的大小
            icon: require('../assets/imgs/common/Maps_bjd.png'),
            offset: new AMap.Pixel(0, 0)
          })
          map.setCenter([121.139418, 41.092875]) // [121.1343344, 41.0915863]
          map.setZoom(16) // 设置地图层级
          _that.marker.setLabel({
            direction: 'right',
            offset: new AMap.Pixel(-10, 0), // 设置文本标注偏移量
            content: '<div class=\'info\'>五十三科技有限公司</div>' // 设置文本标注内容
          })
          map.add(_that.marker) // 添加到地图
        })
        .catch(e => {
          console.log(e)
          // this.$message.error(e)
        })
    },

    // 0正常 1等待支付 2已支付 3等待发货 4已发货 5已完成 6订单超时 7订单取消
    // 转换订单状态
    switchStatus(val) {
      var str = ''
      switch (val) {
        case 0:
          str = '待支付'
          break;
        case 1:
          str = '待支付'
          break;
        case 2:
          str = '待发货'
          break;
        case 3:
          str = '待发货'
          break;
        case 4:
          str = '已发货'
          break;
        case 5:
          str = '已完成'
          break;
        case 6:
          str = '订单超时'
          break;
        case 7:
          str = '订单取消'
          break;
        case 8:
          str = '网络直发'
          break;
        default:
          break;
      }
      return str
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/commonMethods.js